import { h } from "preact";

import { classNames } from "../helpers";
import Icon from "./Icon.jsx";

export default function Star({ empty, full, half }) {
  const classes = classNames(
    "star",
    empty && "star--empty",
    full && "star--full",
    half && "star--half"
  );
  return (
    <span class={classes}>
      {(half || full) && (
        <Icon small class="star__full-star">
          star
        </Icon>
      )}
      {(half || empty) && (
        <Icon small class="star__empty-star">
          star
        </Icon>
      )}
    </span>
  );
}
